// extracted by css-extract-rspack-plugin
export default {"label":"label--bacN4l190BIsnhYD"};